import { useClientPortalAPI } from "@certn/api/src/useClientPortalAPI";
import {
  Layout,
  Loader,
  SecondaryTopNav,
  SectionMessage,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { components } from "@certn/api/generated-schemas/client-portal";
import { WorkableEditStep } from "./components/steps/WorkableEditStep";
import { WorkableIntegrationHeader } from "./WorkableIntegrationHeader";

export function WorkableIntegrationEditPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading, mutate } = useClientPortalAPI(
    "/api/internal/client-portal/ats-integrations/"
  );
  if (isLoading) {
    return <Loader overlay />;
  }

  const initialValues = (
    (data as { results?: components["schemas"]["AtsIntegrationDetail"][] })
      ?.results || []
  ).find(
    (
      result: components["schemas"]["AtsIntegrationDetail"]
    ): result is components["schemas"]["AtsIntegrationDetail"] =>
      result.workable_integration !== null
  );

  return (
    <Layout
      layout="narrow"
      backgroundColor="surface-base"
      header={
        <SecondaryTopNav
          testID="ats-integration-edit-top-nav"
          leftIcon="arrow_back"
          onleftIconOnPress={() => navigate("/settings/ats-integrations")}
          titleArea={{ title: t("Integration details") }}
        />
      }
    >
      <div className={styles.wrapper}>
        {initialValues ? (
          <>
            <WorkableIntegrationHeader
              initialValues={initialValues}
              reload={mutate}
            />
            <WorkableEditStep initialValues={initialValues} reload={mutate} />
          </>
        ) : (
          <SectionMessage
            type="danger"
            sectionTitle={t("Unable to load")}
            icon="error"
          >
            <Trans>Unable to fetch the integration information.</Trans>
          </SectionMessage>
        )}
      </div>
    </Layout>
  );
}

const styles = {
  wrapper: css({
    width: "560px",
    margin: "auto",
  }),
};
